// extracted by mini-css-extract-plugin
export default {"blockWrap":"leaseDur_blockWrap__hFRU9","fullWidth":"leaseDur_fullWidth__VSoQL","thirdWidth":"leaseDur_thirdWidth__9pSEZ","title":"leaseDur_title__LYxOP"};